<div class="sk-cms-search-detail-wap sk-cms-search-get"
     {{if style.background.styleType != 'default'}}
     {{if style.background.backgroundType == 'color'}}
style="background-color:{{style.background.color}}"
{{/if}}
{{if style.background.backgroundType == 'img'}}
style="background-image:url('{{style.background.imgUrl}}')"
{{/if}}
{{/if}}
>
  <div class="search-area">
    <span class="smarket icons-backleft" sk-event.click="goBack()"></span>
    <input type="search" id="search-input"
           style="{{style.text.model == 'default' ? '': 'color:'+style.text.color}};
            {{style.searchBox.model == 'default' ? '': 'border-color:'+style.searchBox.color}};
            {{style.searchBox.model == 'default' ? '': 'background-color:'+style.searchBox.color2}};
          "
    >
    <span class="smarket icons-sousuo" sk-event.click="checkSearch()"></span>
  </div>
  <div class="history-area" id="history-area">
    <div class="header">
      <div class="title"
           style="{{style.history.model == 'default' ? '': 'color:' + style.history.color}};"
      >历史搜索</div>
      <div class="clear"
           style="{{style.clear.model == 'default' ? '': 'color:' + style.clear.color}};"
           sk-event.click="clearKeyword()"
      >清空</div>
    </div>
    {{if isDesign || isPreview}}
    {{else}}
    <div id="search-style" style="display: none">{{style|json_encode|raw}}</div>
    <div id="keyword-style" style="display: none">{{style.keyword|json_encode|raw}}</div>
    <div id="search-tab-style" style="display: none">{{style.tab|json_encode|raw}}</div>
    <div id="search-tab-active-style" style="display: none">{{style.tabActive|json_encode|raw}}</div>
    <div id="search-data-title-style" style="display: none">{{style.title|json_encode|raw}}</div>
    <div id="search-data-desc-style" style="display: none">{{style.desc|json_encode|raw}}</div>
    {{/if}}

    <div class="list" id="search-keyword-list">
      <!--<div class="item">线上会</div>-->
      <!--<div class="item">线上会</div>-->
      <!--<div class="item">线上会</div>-->
      <!--<div class="item">线上会</div>-->
      <!--<div class="item">线上会啊</div>-->
      <!--<div class="item">线上会</div>-->
      <!--<div class="item">线上会啊啊</div>-->

    </div>
  </div>

  <div class="tab" id="search-tab">
  {{each content.items}}

    <div class="item {{$value.isDefault == 1 ? 'active' : ''}}"
               sk-event.click="checkTab('{{$value.type}}',{{$index}},{{style.tabActive}},{{style.tab}})"
               style="{{$value.isDefault == 1 && style.tabActive.default != 'default' ? 'color:' + style.tabActive.color : ''}};
                      {{$value.isDefault == 1 && style.tabActive.default != 'default' ? 'border-color:' + style.tabActive.color : ''}};
                      {{$value.isDefault != 1 && style.tab.default != 'default' ? 'color:' + style.tab.color : ''}};
                      {{$value.isDefault != 1 && style.tabActive.default != 'default' ? 'border-color:' + style.tabActive.color : ''}};
                      {{$value.isShow != 1 ? 'display: none' : ''}}
                      "
          >{{$value.title}}</div>

  {{/each}}
  </div>

  <div class="data-list" id="search-data-list">
    <div class="no-data" >
      暂无数据
    </div>
    <div class="data-loading" >
      加载中...
    </div>
    <!--<div class="item">-->
      <!--<div class="title">CIMT 2021，机床展，来FANUC就对了！</div>-->
      <!--<div class="desc">FANUC机器人典型应用及智能制造整体解</div>-->
    <!--</div>-->
    <!--<div class="item">-->
      <!--<div class="title">CIMT 2021，机床展，来FANUC就对了！</div>-->
      <!--<div class="desc">FFANUC机器人典型应用及智能制造整体解FANUC机器人典型应用及智能制造整体解FANUC机器人典型应用及智能制造整体解ANUC机器人典型应用及智能制造整体解</div>-->
    <!--</div>-->
    <!--<div class="item">-->
      <!--<div class="title">CIMT 2021，机床展，来FANUC就对了！</div>-->
      <!--<div class="desc">FANUC机器人典型应用及智能制造整体解</div>-->
    <!--</div>-->
  </div>
</div>
